export const filterIncentiveTypes = () => {
    const incentiveTypes = ['Pre-Sales', 'Sales', 'Non-Sales']
    return incentiveTypes
  }
  